import React from 'react';
import { Sprout, CalendarDays } from 'lucide-react';

/**
 * Placeholder for the two Home views that are not built yet (P6 and P9).
 *
 * It exists so the switch itself can be reviewed and lived with before the
 * views behind it are real. Both segments are flagged off by default, so no
 * member sees this unless someone deliberately turns it on.
 */

const CONTENT = {
  tracker: {
    icon: Sprout,
    title: 'Track what matters to you.',
    body: 'Small, steady steps. Your trackers will live here — solat, Quran, sedekah, or whatever you choose to keep an eye on.',
  },
  updates: {
    icon: CalendarDays,
    title: "What's on, and when.",
    body: 'Events, classes and volunteer calls arranged by date, so you can see what is coming up this week at a glance.',
  },
};

export default function ComingSoonView({ view }) {
  const { icon: Icon, title, body } = CONTENT[view] || CONTENT.tracker;

  return (
    <div className="px-4 pt-6 desktop-shell" data-testid={`coming-soon-${view}`}>
      <div className="rounded-2xl border border-border bg-muted/30 p-6 text-center flex flex-col items-center">
        <span className="h-12 w-12 rounded-full bg-[#E8F5E9] flex items-center justify-center">
          <Icon className="h-6 w-6 text-[#0F4C4A]" />
        </span>
        <h2 className="mt-3 text-base font-bold text-foreground">{title}</h2>
        <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed max-w-[300px]">{body}</p>
        <p className="mt-4 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          Coming soon
        </p>
      </div>
    </div>
  );
}
